import { TrendingUp } from "lucide-react";

const DynamicPriceDisplay = ({ 
  dynamicPricing, 
  showOriginal = true,
  size = "default", // "sm", "default", "lg"
  className = "" 
}) => {
  if (!dynamicPricing) return null;

  const { 
    base_price, 
    current_price, 
    increase_percent, 
    dynamic_pricing_active 
  } = dynamicPricing;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-AU', { 
      style: 'currency', 
      currency: 'AUD' 
    }).format(price || 0);
  };

  const sizeClasses = {
    sm: {
      current: "text-lg font-bold",
      original: "text-xs",
      increase: "text-xs"
    },
    default: {
      current: "text-2xl font-bold",
      original: "text-sm",
      increase: "text-sm"
    },
    lg: {
      current: "text-3xl font-bold",
      original: "text-base",
      increase: "text-base"
    }
  };

  const sizes = sizeClasses[size] || sizeClasses.default;

  // If no dynamic pricing active, show simple price
  if (!dynamic_pricing_active) {
    return (
      <div className={`${className}`} data-testid="price-display">
        <span className={`${sizes.current} text-slate-900`}>
          {formatPrice(current_price)}
        </span>
      </div>
    );
  }

  // Dynamic pricing active - show with original price and increase
  return (
    <div className={`${className}`} data-testid="price-display">
      <div className="flex items-center gap-2">
        <span className={`${sizes.current} text-slate-900`}>
          {formatPrice(current_price)}
        </span>
        {increase_percent > 0 && (
          <span className={`${sizes.increase} text-red-500 flex items-center gap-0.5 font-medium`}>
            <TrendingUp className="w-3 h-3" />
            +{increase_percent}%
          </span>
        )}
      </div>
      {showOriginal && base_price !== current_price && (
        <div className={`${sizes.original} text-muted-foreground`}>
          <span className="line-through">{formatPrice(base_price)}</span>
          <span className="ml-1 text-green-600 font-medium">Original price</span>
        </div>
      )}
    </div>
  );
};

export default DynamicPriceDisplay;
